// extracted by mini-css-extract-plugin
module.exports = {"content":"AnnouncementCard_content__uu5zC"};